"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var react_1 = __importDefault(require("react"));
var AsyncSelect_1 = require("./AsyncSelect");
var StaticSelect_1 = require("./StaticSelect");
var UseSelectUtils_1 = require("./hooks/UseSelectUtils");
var Select = function (props) {
    if (UseSelectUtils_1.isAsyncConfiguration(props)) {
        return react_1.default.createElement(AsyncSelect_1.AsyncSelect, __assign({}, props));
    }
    else {
        return react_1.default.createElement(StaticSelect_1.StaticSelect, __assign({}, props));
    }
};
exports.Select = Select;
//# sourceMappingURL=Select.js.map